import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import UiContext from "../../context/uiProvider"
import AuthContext from "../../context/authProvider"
import { LARGE_TABLET, TABLET } from "../../utils/screenSize"

export default function Logout() {
  const { setAuth } = useContext(AuthContext)
  const { deviceView } = useContext(UiContext)
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const handleLogout = () => {
    setAuth({ token: null, user: null })
    queryClient.clear()
    navigate("/login")
  }

  return (
    <button
      onClick={handleLogout}
      className={`bg-primary block text-white p-2 rounded-lg hover:shadow-right-lg transform active:translate-y-1 active:scale-[.99]  active:shadow-none font-medium ${deviceView >= LARGE_TABLET ? "text-xl" : deviceView >= TABLET ? "text-lg" : "text-base"}`}
    >
      Logout
    </button>
  )
}